import { Components, Theme } from '@mui/material/styles'

export const MuiListItemSecondaryAction: Components<Theme>['MuiListItemSecondaryAction'] =
  {
    styleOverrides: {
      root: {
        position: 'initial',
        inset: 'initial',
        transform: 'none',
      },
    },
  }
